import { computed, defineComponent } from 'vue';
import EmailInput from '@/components/auth/EmailInput.vue';
import OtpInput from '@/components/auth/OtpInput.vue';
import BlockedStatus from '@/components/kyc/BlockedStatus.vue';
import { AuthTypes } from '@/types/auth';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
export default defineComponent({
    name: 'AuthView',
    props: {},
    components: {
        EmailInput,
        OtpInput,
        BlockedStatus,
    },
    setup() {
        const authStore = useAuthStore();
        const { currentStep } = storeToRefs(authStore);
        const stepsList = [
            {
                name: AuthTypes.AuthSteps.AUTH_1,
                component: EmailInput,
            },
            {
                name: AuthTypes.AuthSteps.AUTH_2,
                component: OtpInput,
            },
            {
                name: AuthTypes.AuthSteps.BLOCKED,
                component: BlockedStatus,
            },
        ];
        const activeTab = computed(() => stepsList.find(item => item.name === currentStep.value).component);
        return {
            currentStep,
            stepsList,
            activeTab,
        };
    },
});
